import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const Container = styled(Box)`
  height: 100%;
`;

// flex-grow: 2;
  
export const MessageContainer = styled(Box)`
  padding: 1rem;
  overflow: hidden;
  height: 100%;

  @media screen and (min-width: 900px) {
      max-height: 100%;
      overflow-y: auto;  
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #D9D9D9;       
  }

  & div:first-of-type {
    margin-top: auto;
  }
`;
